import * as manageGameData from "./manageGameData";
import * as config from "./config";
import * as dynamicForms from "./dynamicForms";

export default { ...manageGameData, ...config, ...dynamicForms };
